export const calculateRegistrationText = (
  registrationEndDate: string
): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [datePart] = registrationEndDate.split("-");
  const [day, month, year] = datePart.split("/").map(Number);
  const endDate = new Date(year, month - 1, day);
  endDate.setHours(0, 0, 0, 0);

  const timeDiff = endDate.getTime() - today.getTime();
  const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  if (dayDiff > 0) {
    return `D-${dayDiff}`;
  } else {
    return "모집마감";
  }
};

export const calculateMapCenter = (
  mapRef: any,
  position: any,
  infoWindowHeight: number
) => {
  const mapSize = mapRef.getSize();
  const projection = mapRef.getProjection();

  // 마커 위치를 픽셀 좌표로 변환
  const markerPixel = projection.fromCoordToOffset(position);

  // InfoWindow가 화면 중앙에 오도록 오프셋 계산
  const offsetY = mapSize.height / 2 - infoWindowHeight / 2 - 50;

  // 새로운 중심점 계산
  const newCenterPixel = new window.naver.maps.Point(
    markerPixel.x,
    markerPixel.y - offsetY
  );

  return projection.fromOffsetToCoord(newCenterPixel);
};
